export default {"src":"/_next/static/media/caret-down-dark.d6a17d9e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};